import type { RouteRecordRaw } from 'vue-router';

export const affiliateRoutes: Array<RouteRecordRaw> = [
  {
    path: '/affiliate',
    name: 'affiliate',
    redirect: '/affiliate/list',
    component: () => import('pages/info/affiliate/McAffiliate.vue'),
    meta: {
      title: 'Affiliates',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'affiliateList',
        component: () => import('pages/info/affiliate/AffiliateList.vue'),
        meta: {
          title: 'Affiliate Items List',
          requiresAuth: true,
        },
      },
      {
        path: 'list/detail/:itemId?',
        name: 'affiliateDetail',
        component: () => import('pages/info/affiliate/AffiliateDetail.vue'),
        meta: {
          title: 'Affiliate List Item Details',
          requiresAuth: true,
        },
      },
      {
        path: 'list/new',
        name: 'affiliateNew',
        component: () => import('pages/info/affiliate/AffiliateNew.vue'),
        meta: {
          title: 'New Affiliate List Item',
          requiresAuth: true,
        },
      },

      {
        path: 'rewards',
        name: 'affiliateReward',
        component: () =>
          import('pages/info/affiliate//affiliateReward/AffiliateRewardList.vue'),
        meta: {
          title: 'Affiliate Rewards List',
          requiresAuth: true,
        },
      },
      {
        path: 'reward/detail/:itemId?',
        name: 'affiliateRewardDetail',
        component: () =>
          import('pages/info/affiliate//affiliateReward/AffiliateRewardDetail.vue'),
        meta: {
          title: 'Affiliate Reward Details',
          requiresAuth: true,
        },
      },
      {
        path: 'reward/new',
        name: 'affiliateRewardNew',
        component: () =>
          import('pages/info/affiliate//affiliateReward/AffiliateRewardNew.vue'),
        meta: {
          title: 'New Affiliate Reward',
          requiresAuth: true,
        },
      },

      {
        path: 'usages',
        name: 'affiliateUsage',
        component: () =>
          import('pages/info/affiliate//affiliateUsage/AffiliateUsageList.vue'),
        meta: {
          title: 'Affiliate Usages List',
          requiresAuth: true,
        },
      },
      {
        path: 'usage/detail/:itemId?',
        name: 'affiliateUsageDetail',
        component: () =>
          import('pages/info/affiliate//affiliateUsage/AffiliateUsageDetail.vue'),
        meta: {
          title: 'Affiliate Usage Details',
          requiresAuth: true,
        },
      },
      {
        path: 'usage/new',
        name: 'affiliateUsageNew',
        component: () =>
          import('pages/info/affiliate//affiliateUsage/AffiliateUsageNew.vue'),
        meta: {
          title: 'New Affiliate Usage',
          requiresAuth: true,
        },
      },

      {
        path: 'payment',
        name: 'affiliatePayment',
        component: () =>
          import('pages/info/affiliate//affiliatePayment/AffiliatePaymentList.vue'),
        meta: {
          title: 'Affiliate Payments List',
          requiresAuth: true,
        },
      },
      {
        path: 'payment/detail/:itemId?',
        name: 'affiliatePaymentDetail',
        component: () =>
          import('pages/info/affiliate//affiliatePayment/AffiliatePaymentDetail.vue'),
        meta: {
          title: 'Affiliate Payment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'payment/new',
        name: 'affiliatePaymentNew',
        component: () =>
          import('pages/info/affiliate//affiliatePayment/AffiliatePaymentNew.vue'),
        meta: {
          title: 'New Affiliate Payment',
          requiresAuth: true,
        },
      },
    ],
  },
];
